module.exports = __webpack_public_path__ + "img/senderrand-runner-step-5.66747579.svg";